// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"g0-z","subtitle":"h0-z","wrapper":"i0-z","leftArrow":"j0-z","rightArrow":"k0-z"};